import { AxiosError } from 'axios'
import BackButton from 'components/backButton'
import { Spinner, TextInput } from 'components/common'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { getEcomPricingDetails } from 'utils/api/ecomPricingApi'
import {
  ECOM_PRICING_FORM_FIELDS,
  ERROR_CODES,
  PAGE_NOT_FOUND,
} from 'utils/constants'
import { convertTo12HourFormat } from 'utils/helpers'

const formatEcomDate = (date?: Date) => {
  if (!date) {
    return ''
  }
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

const EcomDetailForm = ({ data }: { data: Record<string, any> }) => {
  const {
    BARCODE,
    BASE_PRICE,
    CLUSTER,
    SPECIAL_PRICE,
    SPECIAL_PRICE_END_DATE,
    SPECIAL_PRICE_START_DATE,
    CREATED_AT,
    UPDATED_AT,
  } = ECOM_PRICING_FORM_FIELDS

  // const navigate = useNavigate()

  const { register } = useForm({
    defaultValues: {
      ...data,
      [CREATED_AT.key]: convertTo12HourFormat(data[CREATED_AT.key]),
      [UPDATED_AT.key]: convertTo12HourFormat(data[UPDATED_AT.key]),
    },
  })
  // const handleUpdateEcomricingData = () => {}

  // const cancelAndGoback = () => {
  //   reset()
  //   navigate(-1)
  // }

  return (
    <>
      <form>
        <div className="flex flex-wrap gap-x-14 gap-y-3">
          <div className="w-64">
            <TextInput
              register={register}
              label={BARCODE.label}
              name={BARCODE.key}
              disabled
            />
          </div>

          <div className="w-64">
            <TextInput
              register={register}
              label={CLUSTER.label}
              name={CLUSTER.key}
              disabled
            />
          </div>
          <div className="w-64">
            <TextInput
              register={register}
              label={BASE_PRICE.label}
              name={BASE_PRICE.key}
              disabled
            />
          </div>
          <div className="w-64">
            <TextInput
              register={register}
              label={SPECIAL_PRICE.label}
              name={SPECIAL_PRICE.key}
              disabled
            />
          </div>
          <div className="w-64">
            <TextInput
              register={register}
              label={CREATED_AT.label}
              name={CREATED_AT.key}
              disabled
            />
          </div>
          <div className="w-64">
            <TextInput
              register={register}
              label={UPDATED_AT.label}
              name={UPDATED_AT.key}
              disabled
            />
          </div>
          <div className="w-64">
            <TextInput
              label={SPECIAL_PRICE_START_DATE.label}
              name={SPECIAL_PRICE_START_DATE.key}
              placeholder={SPECIAL_PRICE_START_DATE.placeholder}
              register={register}
              disabled
            />
          </div>
          <div className="w-64">
            <TextInput
              label={SPECIAL_PRICE_END_DATE.label}
              name={SPECIAL_PRICE_END_DATE.key}
              placeholder={SPECIAL_PRICE_END_DATE.placeholder}
              register={register}
              disabled
            />
          </div>
        </div>
      </form>
    </>
  )
}

const EcomPricingDetail = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<Record<string, any> | null>(null)
  const navigate = useNavigate()

  const { SPECIAL_PRICE_END_DATE, SPECIAL_PRICE_START_DATE } =
    ECOM_PRICING_FORM_FIELDS

  const { id } = useParams()

  // To fetch price based on pricing id
  const getPricingData = async (id: string) => {
    try {
      setLoading(true)
      const { data } = await getEcomPricingDetails(id)
      // Flat obj to be used in hook form
      const flatObj = {
        ...data,
        cluster: data?.cluster,
        barcode: data?.barcode,
      }

      flatObj[SPECIAL_PRICE_START_DATE.key] = formatEcomDate(
        flatObj[SPECIAL_PRICE_START_DATE.key],
      )

      flatObj[SPECIAL_PRICE_END_DATE.key] = formatEcomDate(
        flatObj[SPECIAL_PRICE_END_DATE.key],
      )

      setData(flatObj)
      setLoading(false)
    } catch (error) {
      if (error instanceof AxiosError) {
        const msg = error?.response?.data?.errors?.msg
        if (msg === ERROR_CODES.NOT_FOUND) {
          return navigate(PAGE_NOT_FOUND.path)
        }
      }
    }
  }

  useEffect(() => {
    if (id) {
      getPricingData(id)
    }
  }, [])

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Ecom Pricing Detail</title>
      </Helmet>
      <div>
        <BackButton />
        <div>{data && id && <EcomDetailForm data={data} />}</div>
      </div>
    </>
  )
}

export default EcomPricingDetail
